// Dependencies
import styled, {css, useTheme} from "styled-components";
import { Helpers } from "../../utils";

// Types
import { Components } from "../../types";
import Icon from "../Icon";

export const AddToCartButton = ({translations, ...props}: any) => { 
    const { components: {addToCartButton} }: any = useTheme(); 
    
    return (
        <StyledAddToCartButton type="submit" className="wooptima-add-to-cart-button" {...props}>
            {addToCartButton.showIcon && <Icon id={`cart`} {...props} size={addToCartButton.iconSize} /> }
            <span>{translations.product.addToCart}</span>
        </StyledAddToCartButton>
    )
} 

export const StyledButton = styled.button<any>(
    ({ theme: { general } }) => css`

        font-family: inherit;
        display: flex;
        align-items: center;
        justify-content: center;

        outline: none;
        border: none !important;

        user-select: none;
        cursor: pointer;

        flex: 1 0 auto;
        padding: 0.5em 0;
        ${Helpers.clamp('padding-left', 1, 2, 2.5)};
        ${Helpers.clamp('padding-right', 1, 2, 2.5)};
        height: 100%;
        border-radius: 0 !important;

        text-transform: initial !important;
        font-weight: 700 !important;
        letter-spacing: 0.05em !important;
        
        background: #242424;
        color: #fff;
        
        transition: all ${general.transition.duration} ${general.transition.timingFunction};

        // TODO: Mixin
        &:focus-within {
            box-shadow: 0 0 0 .1em rgba(0, 0, 0, .15) !important;
        }
        
        @media (-moz-touch-enabled: 1), (hover: none), (pointer: coarse) {
            &:focus-within {
                box-shadow: unset !important;
            }
            &:active {
                box-shadow: 0 0 0 .1em rgba(0, 0, 0, .15) !important;
            }
        }
        
        &:focus,
        &:active,
        &:hover {
            color: #fff;
            background: #0f0f0f;
        }
    `
)

export const StyledAddToCartButton = styled(StyledButton)<any>(
    ({ theme: { general, components: {addToCartButton: style} } }) => css`
        border-radius: ${Helpers.getFormattedValue(style.borderRadius || 0)} !important; 
        background: ${style.background} !important;
        color: ${style.textColor} !important;
        text-transform: ${style.textTransform} !important;
        
        svg {
            margin-right: 0;
        }

        span {
            font-size: 0;
            width: 0;
        }
        
        @media (min-width: ${Helpers.getBreakpoint('mobile', 'md')}) {
            svg {
                margin-right: 0.5em;
            }
            span {
                width: fit-content;
                ${Helpers.clamp('font-size', style.textSizeMin, style.textSizeMax, 2.5, true)}
            }
        }

        &:focus,
        &:active,
        &:hover {
            color: ${style.hoverTextColor || style.textColor};
            background: ${style.hoverBackground};
        }
    `
)

export const StyledHomecreditButton = styled(StyledButton)<any>(
    ({ theme: { general, components: {homecreditButton: style} } }) => css`
        padding: 0 1em;
        background: ${style.background};

        &:focus,
        &:active,
        &:hover {
            background: ${style.hoverBackground};
        }

        max-width: max-content;
        svg {
            width: 100%;
            height: 100%;
        }
    `
)